(($, window) ->
  'use strict'
  $ ->
    chateau = new Chateau();
    chateau.init();

    $('.panel-title').on 'click', '> a', (evt) ->
      evt.preventDefault()

  $(window).load ->
    ###$( ->
      if $('#secondary-nav-bar').length
        console.log('here 1');
        sticky = new Waypoint.Sticky(
          element: $('#secondary-nav-bar')[0]
          offset: 0
        )
    )###

) jQuery, window

# ---
